import { legacy_createStore as createStore, combineReducers } from 'redux';
import allDataOfContactReducer from '../AllDataOfContact/AllDataOfContactReducer';

const rootReducer = combineReducers({
    allDataOfUser: allDataOfContactReducer
  });

const store = createStore(rootReducer);

export default store;